import React from "react";
import Header from "../header/Header";
import VTPreviousStage from "../page/VTPreviousStage";

export default function LandingPreviousStage({page}) {
    return (
        <>
            <Header headerType="AdminStageDisplayOnly"/>
            <VTPreviousStage/>
        </>
    );
}
